var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Headers'),_c('div',{staticClass:"header-footer"},[_c('router-view',{key:this.$route.path})],1),_c('Footer',{attrs:{"copyright":_vm.copyright}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }